import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import styles from './JobTestSticky.module.scss'
import replaceText from '../../../../common/utils/replaceText'

export const ShowGatsbyImage = ({
  alt,
  image,
  width,
  height,
  className,
  tokens,
}) => {
  return (
    <GatsbyImage
      loading="lazy"
      alt={replaceText(tokens, alt)}
      className={`${className} w-100`}
      image={image}
      objectFit="contain"
      style={{ width, height }}
    />
  )
}

const TestHQSticky = ({ style }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/(jpg)|(png)|(jpeg)/" } }) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)

  const imageMap = {}
  data?.allFile?.edges?.forEach((img) => {
    imageMap[img.node.base] = img.node.childImageSharp.gatsbyImageData
  })

  return (
    <>
      <div className={`w-100 ${styles.main}`}>
        <Link
          to="https://tests.practicereasoningtests.com/shl"
          rel="nofollow"
          target="_blank"
        >
          <ShowGatsbyImage
            alt={'banner'}
            className={`d-none d-md-block ${styles.bannerImage}`}
            image={getImage(imageMap['StickyHeader(Sample).png'])}
          />
          <ShowGatsbyImage
            alt={'banner'}
            className={`d-block d-md-none ${styles.bannerImageMobile}`}
            image={getImage(
              imageMap['mobile-banner-practice-aptitude-tests.jpg'],
            )}
          />
        </Link>
      </div>
    </>
  )
}

export default TestHQSticky
